var __TEMP__ = require('./_root.js');var root = __REQUIRE_DEFAULT__(__TEMP__);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = Uint8Array;
